import React from 'react'
import Component from 'components/component'
import Checkbox from 'components/form/checkbox'
import Validator from 'components/validator'

export default class CheckboxInput extends Component {
  static defaultProps = {
    isRequired: false,
    validators: [],
    getTitle: item => item.title,
    getValue: item => item.value,
    checked: false,
    value: true,
    uncheckedValue: false,
  }

  get validators() {
    return [this.props.isRequired && 'isRequired', ...this.props.validators]
  }

  render() {
    return (
      <Validator
        onValidateForm={this.props.onValidateForm}
        render={({ value, hasError, messages }) => (
          <Checkbox
            checked={value}
            disabled={this.props.disabled}
            error={hasError}
            name={this.props.name}
            uncheckedValue={this.props.uncheckedValue}
            value={this.props.value}
          >
            {this.props.children}
            {hasError && <div className="error">{messages[0]}</div>}
          </Checkbox>
        )}
        validators={this.validators}
        value={this.props.checked}
      />
    )
  }
}
